export const ADD_CARS = "ADD_CARS";

export const ADD_CAR = "ADD_CAR";

export const ADD_EXPENSE = "ADD_EXPENSE";

export const ADD_EXPENSES = "ADD_EXPENSES";

export const ADD_TRIP = "ADD_TRIP";

export const ADD_TRIPS = "ADD_TRIPS";
